var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SaltSpreadingMeasurementFragment',_vm._b({},'SaltSpreadingMeasurementFragment',_vm.$props,false)),_c('MachineMeasurement',_vm._b({},'MachineMeasurement',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }